import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { Kundenbetreuer } from '../../domain/model/kundenbetreuer';
import { take } from 'rxjs/operators';
import { KundenbetreuerService } from '../../service/kundenbetreuer/kundenbetreuer.service';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../service/common/notification/notification.service';
import { ConfirmDialogService } from '../../service/common/confirm-dialog/confirm-dialog.service';

@Component({
    selector: 'tnb-settings-kundenbetreuer-detail',
    templateUrl: './settings-kundenbetreuer-detail.component.html',
    styleUrls: [
        './settings-kundenbetreuer-detail.component.scss',
    ],
    standalone: false,
})
export class SettingsKundenbetreuerDetailComponent implements OnInit {
    private kundenbetreuerService = inject(KundenbetreuerService);
    private activatedRoute = inject(ActivatedRoute);
    private notificationService = inject(NotificationService);
    private confirmDialogService = inject(ConfirmDialogService);
    private changeDetectorRef = inject(ChangeDetectorRef);
    westnetzSidenavService = inject(WestnetzSidenavService);

    public kundenbetreuer: Kundenbetreuer = new Kundenbetreuer();
    public createNew: boolean = false;

    ngOnInit() {
        const kundenbetreuerId = this.activatedRoute.snapshot.queryParams['kundenbetreuer'];
        this.createNew = kundenbetreuerId == null || kundenbetreuerId === '';
        if (kundenbetreuerId) {
            this.kundenbetreuerService.getKundenbetreuer(this.activatedRoute.snapshot.queryParams['kundenbetreuer'])
                .pipe(take(1))
                .subscribe((kundenbetreuer: Kundenbetreuer) => {
                    this.kundenbetreuer = kundenbetreuer;
                    this.changeDetectorRef.markForCheck();
                });
        }
    }

    saveKundenbetreuer() {
        if (this.createNew) {
            this.kundenbetreuerService.createKundenbetreuer(this.kundenbetreuer).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Der Kundenbetreuer wurde erfolgreich angelegt');
            });
        } else {
            this.kundenbetreuerService.saveKundenbetreuer(this.kundenbetreuer).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Der Kundenbetreuer wurde erfolgreich gespeichert');
            });
        }
    }

    async deleteKundenbetreuer(kundenbetreuer: Kundenbetreuer) {
        if (await this.confirmDialogService.confirm(
            'Beachten Sie, dass wenn Sie fortfahren, sowohl der Kundenbetreuer, als auch alle bestehenden Zuordnungen ' +
            'zu Netzbetreibern entfernt werden. Dieser Vorgang kann nicht rückgängig gemacht werden.',
            'Kundenbetreuer entfernen!',
            'warn',
            'Entfernen',
            'Abbrechen',
            'innogy_picto_bin_c-check',
        )) {
            this.kundenbetreuerService.deleteKundenbetreuer(kundenbetreuer).subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.notificationService.success('Der Kundenbetreuer wurde entfernt');
            });
        }
    }

}
